import { axios } from '@/utils/request'

const api = {
  search: '/cuser/search'
}

export default api
// 新闻类型
export function search(params) {
  return axios({
    url: api.search,
    method: 'get',
    params
  })
}
